import { Icon, Row, Text } from "app/components";
import { get, startCase } from "lodash";
import { rActiveBlockId, rPageActions } from "app/utils/recoil";
import { useRecoilState, useRecoilValue } from "recoil";

import { spacing } from "app/utils/theme";
import styled from "styled-components";
import { successNotification } from "app/utils/Notification";
import { truncateText } from "app/utils/utils";
import useBlocks from "app/utils/useBlocks";
import { useState } from "react";

const ActionBubble = ({ action, onClick, multiResourceId, resourceId }) => {
  const [showDelete, setShowDelete] = useState(false);

  const { blocks, setBlocks } = useBlocks();

  const activeBlockId = useRecoilValue(rActiveBlockId);

  const [actions, setActions] = useRecoilState(rPageActions);

  const deleteAction = (e) => {
    e.stopPropagation();

    // Update actions
    setActions(actions.filter((a) => a.id !== action.id));

    // Update blocks
    setBlocks(
      blocks.map((b) => {
        if (b.id === activeBlockId) {
          return {
            ...b,
            [multiResourceId]: get(b, multiResourceId, []).filter(
              (x) => x.value !== action.id
            ),
          };
        }
        return b;
      })
    );

    successNotification("Action Deleted");
  };

  const actionLabel = multiResourceId
    ? get(action, "label")
    : get(action, "referenceLabel") || startCase(resourceId);

  return (
    <Container
      onClick={onClick}
      onMouseEnter={() => {
        if (!showDelete) {
          setShowDelete(true);
        }
      }}
      onMouseLeave={() => {
        if (showDelete) {
          setShowDelete(false);
        }
      }}
    >
      <Icon
        data={{
          icon: "ActionBullseye",
          color: "#5D5F62",
          size: 18,
        }}
      />
      <Row justifyContent="space-between" alignItems="center" width="100%">
        <Text
          data={{
            cursor: "pointer",
            text: truncateText(actionLabel, 25),
            fontStyle: "bodySm",
          }}
        />
        {multiResourceId && showDelete && (
          <Icon
            data={{
              icon: "FiTrash",
              hover: true,
              onClick: deleteAction,
              color: "var(--grey7)",
              size: 18,
            }}
          />
        )}
      </Row>
    </Container>
  );
};

export default ActionBubble;

const Container = styled.div`
  border: 1px solid var(--grey21);
  padding: ${spacing.s3};
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  gap: 5px;
  align-items: center;
  background: white;
`;
